import React, { useState } from 'react';
import style from './About.module.css';

const About = ({about}) => {
  const [showMore, setShowMore] = useState(false);

  const name = about?.name;
  const employees = about?.employees;
  const description = about?.description;
  const ceo = about?.ceo;
  
  if (about === null) {
    return (
      <div>
        <h3 className={style.headline}>About</h3>
        <p className={style.noData}>No data</p>
      </div>
    );
  }

  return (
    <div>
      {name && <h3 className={style.headline}>About {name}</h3>}
      {employees && <div className={style.iconDiv}>
          <img src='/react/phosphor/users-three-duotone.svg' className={style.iconPicture} /><span className={style.iconText}>
            {numberWithCommas(employees)} employees
          </span>
        </div>}
      {ceo && <div className={style.iconDiv}><img src='/react/phosphor/user-circle-duotone.svg' className={style.iconPicture} /><span className={style.iconText}>CEO: {ceo} </span></div>}
      {description &&
        <p className={style.text}>
          {showMore ? description : shorten(description, 240)}
          { description.length > 300 &&
            <button className={style.more} onClick={() => setShowMore(!showMore)}>
              {showMore ? "Show less" : "Show more"}
            </button>
          }
        </p>
      }
    </div>
  );
};

function shorten(text, maxLength) {
  if (text.length > (maxLength + 60)) {
    text = text.substr(0,maxLength-3) + "...";
  }
  return text;
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default About;